module.exports = __webpack_public_path__ + "static/img/NSW-38.29ed481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-38.jpg
// module id = 58+h
// module chunks = 0